import { ActivityLogActionTypes } from './constants';

type ActivityLogAction = { type: string, payload: {} | string };

export const activityLogApiResponseSuccess = (actionType: string, data: any): ActivityLogAction => ({
    type: ActivityLogActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const activityLogApiResponseError = (actionType: string, error: string): ActivityLogAction => ({
    type: ActivityLogActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getLogEntries = (query): ActivityLogAction => ({
    type: ActivityLogActionTypes.GET_LOG_ENTRIES,
    payload: { query },
});

export const activityLogResetState = (): ActivityLogAction => ({
    type: ActivityLogActionTypes.RESET_STATE,
    payload: {},
});
